import React from 'react'

import { HashRouter as Router, Switch, Route } from 'react-router-dom'

import routes from './routes'

const Routes = () => (
  <Router basename="/" hashType="noslash">
    <Switch>
      {routes.map((route) => (
        <Route {...route} key={route.path} />
      ))}
    </Switch>
  </Router>
)

export default Routes
